module.exports = __webpack_public_path__ + "media/images/default/pages/public_science_2/5-e0e1399c16fa93ad3c6e16f56d990fc1.jpg";